import React from "react";

export default function RouteLoading() {
  return (
    <div className="flex min-h-[50vh] items-center justify-center bg-transparent p-6">
      <div className="rounded-xl border border-border bg-card px-5 py-3 text-sm font-semibold text-muted-foreground shadow-sm">
        Loading…
      </div>
    </div>
  );
}